import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { AuthService } from "../services/auth";
import "../styles/components/changePasswordModal.css";

interface ChangePasswordModalProps {
  onClose: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ onClose }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Mật khẩu xác nhận không khớp");
      return;
    }
    setSubmitting(true);
    try {
      await AuthService.changePassword({ currentPassword, newPassword, confirmPassword });
      setSuccess("Đổi mật khẩu thành công");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setTimeout(() => onClose(), 900);
    } catch (e: any) {
      setError(e?.message || "Đổi mật khẩu thất bại");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="change-password-modal">
      <div className="change-password-modal__card">
        <div className="change-password-modal__header">
          <h3 className="change-password-modal__title">Đổi mật khẩu</h3>
          <button onClick={onClose} className="change-password-modal__close">×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="change-password-modal__form">
            <label className="change-password-modal__label">Mật khẩu hiện tại</label>
            <div className="change-password-modal__field">
              <input 
                type={showCurrentPassword ? "text" : "password"} 
                value={currentPassword} 
                onChange={(e) => setCurrentPassword(e.target.value)} 
                placeholder="Nhập mật khẩu hiện tại" 
                className="change-password-modal__input"
              />
              <button
                type="button"
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                className="change-password-modal__toggle"
              >
                {showCurrentPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <label className="change-password-modal__label">Mật khẩu mới</label>
            <div className="change-password-modal__field">
              <input 
                type={showNewPassword ? "text" : "password"} 
                value={newPassword} 
                onChange={(e) => setNewPassword(e.target.value)} 
                placeholder="Nhập mật khẩu mới" 
                className="change-password-modal__input"
              />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                className="change-password-modal__toggle"
              >
                {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <label className="change-password-modal__label">Xác nhận mật khẩu mới</label>
            <div className="change-password-modal__field">
              <input 
                type={showConfirmPassword ? "text" : "password"} 
                value={confirmPassword} 
                onChange={(e) => setConfirmPassword(e.target.value)} 
                placeholder="Nhập lại mật khẩu mới" 
                className="change-password-modal__input"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="change-password-modal__toggle"
              >
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            {error && <div className="change-password-modal__message change-password-modal__message--error">{error}</div>}
            {success && <div className="change-password-modal__message change-password-modal__message--success">{success}</div>}

            <button type="submit" disabled={submitting} className="change-password-modal__submit">
              {submitting ? 'Đang xử lý...' : 'Đổi mật khẩu'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;


